import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

/*
 * Тема в цветах окна настроек расширения (mavo-dash, SettingsDialog.less):
 * индиго #5368F0, тёмный текст #1d2130, скругления 10–14px, Inter.
 */
const FONT = 'Inter, -apple-system, "Segoe UI", Roboto, sans-serif';

export const theme = createMuiTheme({
	typography: {
		useNextVariants: true,
		fontFamily: FONT,
		button: {
			textTransform: 'none',
			fontWeight: 600,
			letterSpacing: 0,
		},
	},
	shape: {
		borderRadius: 10,
	},
	palette: {
		type: 'light',
		primary: {
			main: '#5368F0',
			dark: '#4557E0',
		},
		secondary: {
			main: '#FF7D4D',
			contrastText: '#FFF',
		},
		text: {
			primary: '#1d2130',
			secondary: '#6b7285',
		},
	},
	overrides: {
		MuiFab: {
			root: {
				boxShadow: 'none',
			},
		},
		MuiButton: {
			root: {
				borderRadius: 10,
				padding: '7px 16px',
				fontSize: 14,
			},
			contained: {
				boxShadow: 'none',
				'&:hover': {
					boxShadow: 'none',
				},
			},
			containedPrimary: {
				boxShadow: '0 4px 14px rgba(83, 104, 240, 0.28)',
				'&:hover': {
					boxShadow: '0 6px 18px rgba(83, 104, 240, 0.36)',
				},
			},
			containedSecondary: {
				background: 'linear-gradient(135deg, #ffb660, #ff7d4d)',
				boxShadow: '0 4px 14px rgba(255, 125, 77, 0.28)',
				'&:hover': {
					background: 'linear-gradient(135deg, #ffab4d, #f96f3c)',
				},
			},
			containedSizeLarge: {
				padding: '11px 24px',
				fontSize: 15.5,
				borderRadius: 12,
			},
			outlined: {
				borderColor: '#e1e4ec',
			},
		},
		MuiPaper: {
			rounded: {
				borderRadius: 14,
			},
		},
	},
});

export default theme;
